import { IconButton, Typography, styled, useTheme } from "@mui/material";
import { Left } from "assets/Icon";

import React from "react";
import { useNavigate } from "react-router-dom";

function BackButton({ text, icon, to }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleBackNavigate = () => {
    navigate(to);
  };

  return (
    <IconButtonBack aria-label="back" onClick={handleBackNavigate}>
      {icon || <Left color={theme.palette.text.main} />}
      <Typography variant="h6" ml={1} color={theme.palette.text.main}>
        {text}
      </Typography>
    </IconButtonBack>
  );
}

const IconButtonBack = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(1.2),
  color: theme.palette.text.main,
  marginRight: "10px",
  display: "flex",
  alignItems: "center",
  borderRadius: "5px",
  svg: {
    fontSize: "20px",
  },
}));

export default BackButton;
